import UserClusteringEditor from './UserClusteringEditor';
import UserClusteringList from './UserClusteringList';
import UserClusteringForm from './UserClusteringForm';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import React from 'react';

class UserClusteringView extends React.Component {
    constructor() {
        super();
        this.state = {
            currentView: 'List',
            createOrEdit: false
        };
    }

    render() {
        return <Router basename="/user_profile/clustering">
            <Switch>
                <Route path="/new" exact render={() => {
                    return <UserClusteringEditor
                        onBackward={() => window.location = '/user_profile/clustering'}
                        createOrEdit={true}
                        clusteringId={0}
                    />
                }} />
                <Route path="/:id/edit" exact render={(history) => {
                    const clusteringId = history.match.params.id;
                    return <UserClusteringEditor
                        onBackward={() => window.location = '/user_profile/clustering'}
                        createOrEdit={false}
                        clusteringId={clusteringId}
                    />
                }} />
                <Route path="/:id" render={(history) => {
                    const clusteringId = history.match.params.id;
                    console.log(clusteringId);
                    return <UserClusteringForm
                        onBackward={() => window.location = '/user_profile/clustering'}
                        clusteringId={clusteringId}
                    />
                }} />
                <Route path="/" exact render={() => {
                    return <UserClusteringList
                        onEditClustering={(id) => window.location = `/user_profile/clustering/${id}/edit`}
                        onCreateClustering={() => window.location = '/user_profile/clustering/new'}
                        onOpenClustering={(id) => window.location = `/user_profile/clustering/${id}/form`}
                    />
                }} />
            </Switch>
        </Router>
    }
}

export default UserClusteringView;